import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/views/home/index.vue'
import Service from '@/views/service/index.vue'
import Cooperation from '@/views/cooperation/index.vue'
import Show from '@/views/show-page/index.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: '首页',
      component: Home
    },
    {
      path: '/service',
      name: '服务模式',
      component: Service
    },
    {
      path: '/cooperation',
      name: '合作对接',
      component: Cooperation
    },
    {
      path: '/show',
      name: '平台演示',
      component: Show
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js